import React from "react";
import { Container, Col, Navbar, Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { LoginTopNavIcon,LoginTopNavIcon2, RegisterTopNavIcon, ContactTopNavIcon, HomeTopNavIcon, AboutTopNavIcon } from '../../utils/FontIcon';

function TopMenu() {
    const navigate = useNavigate();
    const location = useLocation();
    const handelLoginClick = () => {
        navigate("/login");
    };
    const handelRegisterClick = () => {
        navigate("/register");
    };
    return (
        <Col lg={12} className="top-navbar">
            <Navbar collapseOnSelect expand="lg" className="top-navbar">
                <Container fluid>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <span className="d-flex d-md-none" style={{gap:'16px'}}>
                        <Nav.Link className="hightligh-link" onClick={handelLoginClick}>
                            <LoginTopNavIcon /> Login</Nav.Link>
                            <Nav.Link eventKey={2} onClick={handelRegisterClick}>
                                <RegisterTopNavIcon />  Register
                                </Nav.Link>
                                </span>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto gap-3">
                            <Nav.Link
                                onClick={() => { navigate("/") }}
                                className={location.pathname === "/" ? "active" : ""}><HomeTopNavIcon />Home</Nav.Link>
                            <Nav.Link
                                onClick={() => { navigate("/aboutus") }}
                                className={location.pathname === "/aboutus" ? "active" : ""}
                            ><AboutTopNavIcon />About Us</Nav.Link>
                            <Nav.Link
                                onClick={() => { navigate("/contact") }}
                                className={location.pathname === "/contact" ? "active" : ""}
                            ><ContactTopNavIcon />Contact Us</Nav.Link>
                        </Nav>
                        <span className="d-none d-md-flex d-lg-flex">
                        <Nav className="gap-3">
                            <Nav.Link className="hightligh-link" onClick={handelLoginClick}>
                                <LoginTopNavIcon2 /> Login</Nav.Link>
                            <Nav.Link eventKey={2} onClick={handelRegisterClick}>
                                <RegisterTopNavIcon />  Register
                            </Nav.Link>
                        
                        </Nav>
                        </span>
                    </Navbar.Collapse>
                    
                </Container>
            </Navbar>
        </Col>
    );
}

export default TopMenu;
